import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class CompanyHolidayService extends Service {
	constructor(injector: Injector) {
		super("CompanyHoliday", injector);
	}

	// API
	forYear(year: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForYear/${year}`);
	}
}